import axios from 'axios'

const ai = {
  url: '/ai/',
  search ({ search, ordering, pageNum=1, count=100, filter={} } = {}, ignoreErrorHandle=false) {
    var paramObject = Object.assign({}, { search, ordering, page: pageNum, count }, filter)
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}search/`, {
        params: paramObject,
        ignoreErrorHandle: ignoreErrorHandle
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  chat ({ query, model_id, history, system_prompt='', filter={}, top_k, similarity_threshold } = {}, ignoreErrorHandle=false) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}chat/`, {
        query,
        model_id,
        history,
        system_prompt,
        top_k,
        similarity_threshold,
      }, {
        params: filter,
        ignoreErrorHandle: ignoreErrorHandle
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  ai
}
